/**
 * The spreadsheet chrome the Excel preview draws around a sheet - shared by
 * the matrix sheet and the « Notes » sheet (issue #19): the row-number gutter,
 * the column-letter row and the grey of both.
 */
export const GUTTER_WIDTH_PX = 40;
export const LETTER_ROW_HEIGHT_PX = 20;
export const BORDER_WIDTH_PX = { thin: 1, medium: 2 } as const;
export const CHROME_CLASS =
  'border-r border-b border-gray-300 bg-gray-100 text-center text-gray-600 font-normal';

/** The spreadsheet's column name for a 0-based index: A…Z, AA, AB… */
export function columnLetters(index: number): string {
  let remaining = index + 1;
  let letters = '';
  while (remaining > 0) {
    const offset = (remaining - 1) % 26;
    letters = String.fromCharCode(65 + offset) + letters;
    remaining = Math.floor((remaining - 1) / 26);
  }
  return letters;
}
